<template>
    <el-pagination
        v-if="isShow"
        class="pagination"
        layout="slot, prev, pager, next, jumper"
        :current-page="innerPageNum"
        :page-size="innerPageSize"
        :total="innerTotal"
        @current-change="handleCurrentChange"
    >
        <div class="total">
            <span>共</span>
            <span class="number">{{ innerTotal }}</span>
            <span>条</span>
        </div>
        <div class="sizes">
            <span>每页</span>
            <el-select v-model="innerPageSize" size="small" @change="handleSizeChange">
                <el-option v-for="item in innerPageSizes" :key="item" :label="item" :value="item" />
            </el-select>
            <span>条</span>
        </div>
    </el-pagination>
</template>

<script>
import utils from '@/utils';

export default {
    name: 'SyPagination',
    props: {
        /**
         * 当前页
         */
        pageNum: {
            type: Number,
            default: utils.defaultPageNum
        },
        /**
         * 页尺寸
         */
        pageSize: {
            type: Number,
            default: utils.defaultPageSize
        },
        /**
         * 页尺寸待选项
         */
        pageSizes: {
            type: Array,
            default: () => utils.defaultPageSizes
        },
        /**
         * 总条数
         */
        total: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            // 当前页
            innerPageNum: 1,
            // 总条数
            innerTotal: 0,
            // 页尺寸
            innerPageSize: 10,
            // 页尺寸待选项
            innerPageSizes: []
        };
    },
    computed: {
        /**
         * 总条数大于0时才显示分页条
         */
        isShow() {
            return this.innerTotal > 0;
        }
    },
    watch: {
        /**
         * 监听pageNum属性
         * @param newValue
         * @param oldValue
         */
        pageNum(newValue, oldValue) {
            this.innerPageNum = newValue;
        },
        /**
         * 监听pageSize属性
         * @param newValue
         * @param oldValue
         */
        pageSize(newValue, oldValue) {
            this.innerPageSize = newValue;
        },
        /**
         * 监听pageSizes属性
         * @param newValue
         * @param oldValue
         */
        pageSizes(newValue, oldValue) {
            this.innerPageSizes = newValue;
        },
        /**
         * 监听total属性
         * @param newValue
         * @param oldValue
         */
        total(newValue, oldValue) {
            this.innerTotal = newValue;
        }
    },
    created() {
        this.innerPageNum = this.pageNum;
        this.innerPageSize = this.pageSize;
        this.innerPageSizes = this.pageSizes;
        this.innerTotal = this.total;
    },
    methods: {
        /**
         * 改变页码
         * @param pageNum 新页码
         */
        handleCurrentChange(pageNum) {
            this.$emit('current-change', pageNum);
        },
        /**
         * 改变每页显示条数
         * @param pageSize 新页码大小
         */
        handleSizeChange(pageSize) {
            this.$emit('size-change', pageSize);
        }
    }
};
</script>

<style lang="scss" scoped>
.pagination {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    padding: 15px 24px;
    color: #606266;
    font-weight: normal;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    line-height: 1;

    .total {
        .number {
            margin-right: 4px;
            margin-left: 4px;
        }
    }

    .sizes {
        margin: 0 20px;
    }

    &::v-deep {
        button,
        span {
            min-width: 0;
        }

        .el-select .el-input {
            width: 70px;
            margin: 0 6px;

            .el-select__caret {
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }

        .el-input--mini {
            font-size: 14px;
        }

        .el-input--small {
            font-size: 14px;

            .el-input__inner {
                height: 28px;
                line-height: 28px;
            }
        }

        .el-icon {
            font-size: 14px;
        }

        .el-pager li {
            font-size: 14px;
        }

        .el-pagination__jump {
            margin-left: 20px;

            .el-pagination__editor {
                margin: 0 6px;
                padding: 0;
            }
        }

        span {
            display: inline;
            color: #606266;
            font-weight: normal;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC, sans-serif;
            line-height: 28px;
        }
    }
}
</style>
